import type { EarliestConsumptionPerLocationDTO } from '@/src/api/types/procurement'

type ReferencePeriodPickerConfig = {
  minSelectableDate?: Date
  maxSelectableDate: Date
  disabledYears?: number[]
  filterDate?: (date: Date) => boolean
}

const getMostRecentEarliestConsumptionEntry = (earliestConsumption?: EarliestConsumptionPerLocationDTO[] | null) => {
  if (!earliestConsumption?.length) return null

  let mostRecentEntry = earliestConsumption[0]
  for (const entry of earliestConsumption) {
    if (new Date(entry.earliestConsumptionDateTime).getTime() > new Date(mostRecentEntry.earliestConsumptionDateTime).getTime()) {
      mostRecentEntry = entry
    }
  }

  return mostRecentEntry
}

export const getMinLatestReferenceDateTime = (earliestConsumption?: EarliestConsumptionPerLocationDTO[] | null): string | null => {
  if (!earliestConsumption?.length) return null

  let min = earliestConsumption[0].latestReferenceDateTime
  for (const entry of earliestConsumption) {
    if (new Date(entry.latestReferenceDateTime).getTime() < new Date(min).getTime()) {
      min = entry.latestReferenceDateTime
    }
  }

  return min
}

export const getReferencePeriodPickerConfigFromEarliestConsumption = (
  earliestConsumption?: EarliestConsumptionPerLocationDTO[] | null
): ReferencePeriodPickerConfig => {
  const referenceConsumptionEntry = getMostRecentEarliestConsumptionEntry(earliestConsumption)

  const maxSelectableDate = new Date()

  if (!referenceConsumptionEntry) {
    return { maxSelectableDate }
  }

  const startYear = Number(referenceConsumptionEntry.earliestFullYear)
  const enabledMinTime = new Date(startYear, 0, 1).getTime()

  return {
    minSelectableDate: new Date(startYear - 1, 0, 1),
    maxSelectableDate,
    disabledYears: [startYear - 1],
    filterDate: (date: Date) => date.getTime() >= enabledMinTime,
  }
}
